import React from 'react';
import { Field, reduxForm } from 'redux-form';
import {
  FormGroup,
  InputGroup,
  Button,
  ButtonToolbar,
  ControlLabel,
  FormControl,
} from 'react-bootstrap';
import { required } from '../../../forms';

export const renderBootstrapField = ({ input, label, type, meta: { touched, error, warning } }) => (
  <InputGroup>
    { label && (<ControlLabel>{label}</ControlLabel>)}
    <FormControl
      {...input}
      type={type}
    />
    {touched &&
      ((error && <span>{error}</span>) ||
        (warning && <span>{warning}</span>))}
  </InputGroup>
);

const EmailForm = (props) => {
  const { handleSubmit, pristine, reset, submitting } = props;
  return (
    <div>
      <form onSubmit={handleSubmit}>
        <FormGroup>
          <Field
            name="name"
            type="text"
            component={renderBootstrapField}
            label="Name"
            validate={[required]}
          />
        </FormGroup>
        <FormGroup>
          <Field
            name="email"
            type="text"
            component={renderBootstrapField}
            label="Email"
            validate={[required]}
          />
        </FormGroup>
        <FormGroup>
          <ButtonToolbar>
            <Button
              disabled={submitting}
              bsStyle="info"
              type="submit"
            >
              <i className="fa fa-envelope fa-lg" /> Send
            </Button>
          </ButtonToolbar>
        </FormGroup>
      </form>
    </div>
  );
};

export default reduxForm({
  form: 'EmailForm', // a unique identifier for this form
})(EmailForm);



// WEBPACK FOOTER //
// src/routes/tours/components/EmailForm.js